export interface CreateUserInput {
  email: string;
  password: string;
  role: "admin" | "user";
}

export interface ValidationError {
  field: keyof CreateUserInput;
  message: string;
}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateCreateUser(input: CreateUserInput): ValidationError[] {
  const errors: ValidationError[] = [];

  if (input.email.length === 0) {
    errors.push({ field: "email", message: "Pflichtfeld" });
  } else if (!EMAIL_REGEX.test(input.email)) {
    errors.push({ field: "email", message: "ungültige Email" });
  }

  if (input.password.length < 8) {
    errors.push({ field: "password", message: "mindestens 8 Zeichen" });
  }

  if (input.role !== "admin" && input.role !== "user") {
    errors.push({ field: "role", message: "admin oder user" });
  }

  return errors;
}
